import * as mixpanel from "./mixpanelWrapper";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

export default mixpanel;
